// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"8c1786c7","230":"0b1e40b7","272":"12202ead"}[chunkId] + ".chunk.css";
};